import {useTranslation} from 'react-i18next';

import {TRANSLATION_KEYS} from 'locale';
import {ClientJoinSession} from 'pages/Client';

import {whiteLabelPreviewEvents} from '../WhiteLabelPreviewEvents';

const T_KEYS = TRANSLATION_KEYS.USER.CONTENT.CLIENT_SESSION.WHITE_LABEL.PREVIEW_MODAL;
const T_ELEMENT_CLICKED = T_KEYS.EVENTS.ELEMENT_CLICKED;

const CLIENT_JOIN_MATCH_PARAMS = {
    match: {
        code: null,
        pin: null,
    },
};

export const ClientJoinSessionPagePreview: React.FC = () => {
    const {t} = useTranslation();
    const elementClicked = () => {
        whiteLabelPreviewEvents.mock(t(T_ELEMENT_CLICKED));
    };
    return <ClientJoinSession {...CLIENT_JOIN_MATCH_PARAMS} onSubmit={elementClicked} />;
};
